// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import React from "react";
import { Link } from "@reach/router";
import { RouteComponentProps } from "@reach/router";
import { Button, Layout, Divider } from "antd";
import PageHeader from "../../components/PageHeader";
import PageBody from "../../components/PageBody";
import PageTitle from "../../components/PageTitle";
import { useTranslation } from "react-i18next";
import logger from "../../../utils/logger";
import configuration from "../../../utils/Config";

const ForbiddenView: React.FunctionComponent<RouteComponentProps> = () => {
  const { t } = useTranslation();
  return (
    <>
      <Layout style={{ height: "100vh" }} className="content-container">
        <Layout.Content className="content">
          <PageHeader>
            <PageTitle title={t("dashboard.title")} />
          </PageHeader>

          <PageBody>
            <div className="text-center">{t("auth.unauthorized")}</div>
            <Divider />
            <div className="text-center">
              <Button type="default" className="btn-secondary">
                <Link
                  to="#"
                  className="user-logout"
                  onClick={() => {
                    logger.debug("Log out");
                    window.location.href = `${configuration.backendBaseUrl}/auth/logout?post_logout_redirect_uri=${configuration.postLogoutUrl}`;
                  }}
                >
                  {t("global.logout")}
                </Link>
              </Button>
            </div>
          </PageBody>
        </Layout.Content>
      </Layout>
    </>
  );
};

export default ForbiddenView;
